import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { BxDisclaimContent, BxDisclaimEvent, BxDisclaimModule } from '@buildxact/ui-components/bx-disclaim';
import { BxHelpNoteModule } from '@buildxact/ui-components/bx-help-note';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { FeatureService } from '../../../core/services/permission/feature.service';
import { PermissionService } from '../../../core/services/permission/permission.service';
import { EstimateActions } from '../../estimates/estimate-view/shell';
import { QuoteRequestsService } from '../quoterequest.service';
import { BxNoticesModule } from './../../../core/components/bx-notices/bx-notices.module';
import { BxPermissionNotificationModule } from './../../../core/components/bx-permission-notification/bbx-permission-notification.module';
import { BxHelpNoteWrapperModule } from './../../../shared/bx-help-note-wrapper/bx-help-note-wrapper.component';
import { QuoteRequestsStores } from './domain';
import { QuoteRequestsNoticeService } from './quote-requests-notice.service';
import { UIQuoteRequestsTableComponent } from '../ui-components/ui-quoterequests-table/ui-quoterequests-table.component';

@Component({
    selector: 'app-quoterequest-list',
    templateUrl: './quoterequest-list.component.html',
    standalone: false,
})
export class QuoteRequestListComponent implements OnInit {
    items: any[] = [];

    showingDeleted = false;

    // @ts-ignore TS7008
    quoteRequestRecipient;

    // @ts-ignore TS2564
    public modulePermitted$: Observable<boolean>;
    // @ts-ignore TS2564
    public notices$: Observable<BxDisclaimContent[]>;

    constructor(
        private quoteRequestsService: QuoteRequestsService,
        private readonly quoteRequestsNoticeService: QuoteRequestsNoticeService,
        private readonly quoteRequestsStores: QuoteRequestsStores,
        private readonly permissionService: PermissionService,
        private readonly featureService: FeatureService
    ) {}

    ngOnInit() {
        this.modulePermitted$ = this.permissionService.getState('request-for-quote.rfq-access.rfq-menu').pipe(
            filter((isAvailable) => !!isAvailable),
            switchMap(() => this.featureService.getState('quoterequests'))
        );
        this.notices$ = this.quoteRequestsStores.quoteRequestsNotices$;
    }

    public onDisclaimClicked(event: BxDisclaimEvent) {
        if (event.action === EstimateActions.View) {
            this.quoteRequestsService.expandRecipientId = event.data.quoteRequestId;
        }
        this.quoteRequestsNoticeService.updateQuoteRequestRecipient(
            <EstimateActions>event.action,
            event.data.quoteRequestId,
            event.data.noticeId
        );
    }

    public onDismissAll() {
        this.quoteRequestsNoticeService.dismissAllQuoteRequestNotices();
    }
}

@NgModule({
    imports: [
        CommonModule,
        BxHelpNoteModule,
        BxNoticesModule,
        BxHelpNoteWrapperModule,
        BxPermissionNotificationModule,
        UIQuoteRequestsTableComponent,
        BxDisclaimModule,
    ],
    declarations: [QuoteRequestListComponent],
    exports: [QuoteRequestListComponent],
})
export class QuoteRequestListModule {}
